<template>
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
      <div
        class="relative overflow-hidden border-b border-gray-200 shadow sm:rounded-lg"
      >
        <table
          class="min-w-full divide-y divide-gray-200 border-b border-gray-200"
        >
          <thead
            class="whitespace-nowrap bg-white text-xs uppercase text-slate-50"
          >
            <tr>
              <th
                scope="col"
                class="p-6 text-left text-xs font-medium tracking-wider text-gray-700"
              >
                Tier
              </th>
              <th
                scope="col"
                class="p-6 text-left text-xs font-medium tracking-wider text-gray-700"
              >
                Companies
              </th>
              <th
                scope="col"
                class="p-6 text-left text-xs font-medium tracking-wider text-gray-700"
              >
                Sources
              </th>
              <th
                scope="col"
                class="p-6 text-left text-xs font-medium tracking-wider text-gray-700"
              >
                Locations
              </th>
              <th
                scope="col"
                class="p-6 text-left text-xs font-medium tracking-wider text-gray-700"
              >
                Pollutants
              </th>
              <th
                scope="col"
                class="p-6 text-left text-xs font-medium tracking-wider text-gray-700"
              >
                Labels
              </th>
              <th
                scope="col"
                class="p-6 text-left text-xs font-medium tracking-wider text-gray-700"
              >
                Manual Entry
              </th>
              <th
                scope="col"
                class="p-6 text-left text-xs font-medium tracking-wider text-gray-700"
              >
                Bulk Upload
              </th>
              <th
                scope="col"
                class="p-6 text-left text-xs font-medium tracking-wider text-gray-700"
              >
                Audit Log
              </th>
              <th
                scope="col"
                class="p-6 text-left text-xs font-medium tracking-wider text-gray-700"
              >
                Integration
              </th>
              <th
                scope="col"
                class="p-6 text-left text-xs font-medium tracking-wider text-gray-700"
              >
                Disclosure Reports
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="{
                id,
                title,
                multiple_companies,
                sources,
                locations,
                pollutants,
                labels,
                manual_entry,
                bulk_upload,
                audit_log,
                integrations,
                disclosure_reports,
              } in tiers"
              :key="id"
              class="bg-white capitalize"
            >
              <td class="whitespace-nowrap px-6 py-4 text-sm text-blue-500">
                <NuxtLink
                  :to="{
                    path: `/superadmin/tiers/edit/${id}`,
                    query: {
                      title,
                      multiple_companies,
                      sources,
                      locations,
                      pollutants,
                      labels,
                      manual_entry,
                      bulk_upload,
                      audit_log,
                      integrations,
                      disclosure_reports,
                    },
                  }"
                >{{ title }}</NuxtLink>
              </td>
              <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                <BooleanIconOrDescription :val="multiple_companies" />
              </td>
              <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                {{ sources }}
              </td>
              <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                {{ locations }}
              </td>
              <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                {{ pollutants }}
              </td>
              <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                <CheckRoundedSmall v-if="labels" /> <TimesRoundedSmall v-else />
              </td>
              <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                <CheckRoundedSmall v-if="manual_entry" />
                <TimesRoundedSmall v-else />
              </td>
              <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                <CheckRoundedSmall v-if="bulk_upload" />
                <TimesRoundedSmall v-else />
              </td>
              <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                <CheckRoundedSmall v-if="audit_log" />
                <TimesRoundedSmall v-else />
              </td>
              <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                <BooleanIconOrDescription :val="integrations" />
              </td>
              <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                <BooleanIconOrDescription :val="disclosure_reports" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TiersTable',

  props: {
    tiersList: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      tiers: this.tiersList,
    }
  },

  watch: {
    tiersList(newList) {
      this.tiers = newList
    },
  },
}
</script>
